import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useVideo } from "../../context/VideoContext";
import { getPortalContainer } from "../../utils/portalContainer";
import {
  getMainLanguageOptions,
  normalizeLanguage,
} from "../../utils/languages";

const WatchReferenceModal = ({ isOpen, onClose, referenceSubtitle, onAddToPlayer }) => {
  const { isFullscreen, isIOS } = useVideo();
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    if (referenceSubtitle) {
      const code = referenceSubtitle.language?.toLowerCase().trim();
      const normalized = normalizeLanguage(code);
      const mainCodes = getMainLanguageOptions().map((l) => l.code);
      if (normalized && mainCodes.includes(normalized)) {
        setLanguage(normalized);
      } else if (referenceSubtitle.source === "file") {
        setLanguage("en");
      }
    }
  }, [referenceSubtitle]);

  const validLangs = getMainLanguageOptions();

  const handleWatch = () => {
    onAddToPlayer(referenceSubtitle, language, 1);
  };

  if (!isOpen) return null;

  const portalContainer = getPortalContainer(isIOS, isFullscreen);
  const subName = referenceSubtitle?.title || referenceSubtitle?.fileName || "بدون نام";

  return ReactDOM.createPortal(
    <div className="scw-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="scw-modal" style={{ maxWidth: "450px" }} onClick={(e) => e.stopPropagation()}>
        <div className="scw-header">
          <h3>تماشای فیلم با یک زیرنویس</h3>
          <div className="scw-header-actions">
            <button className="scw-close-btn" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="scw-scrollable" style={{ padding: "20px" }}>
          <div style={{ marginBottom: "16px" }}>
            <div style={{ fontSize: "13px", color: "var(--text-secondary)", marginBottom: "8px" }}>نام زیرنویس مرجع</div>
            <div style={{ fontSize: "15px", color: "var(--text-primary)", fontWeight: 500, wordBreak: "break-word" }}>{subName}</div>
          </div>
          <div style={{ marginBottom: "16px" }}>
            <div style={{ fontSize: "13px", color: "var(--text-secondary)", marginBottom: "8px" }}>زیرنویس ۱</div>
            <div style={{ fontSize: "12px", color: "var(--text-muted)", marginBottom: "4px" }}>زبان زیرنویس را انتخاب کنید:</div>
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                background: "var(--glass-bg-strong)",
                border: "1px solid var(--glass-border-strong)",
                borderRadius: "8px",
                color: "var(--text-primary)",
                fontSize: "14px",
                cursor: "pointer",
                outline: "none",
              }}
            >
              {validLangs.map((lang) => (
                <option key={lang.code} value={lang.code}>{lang.name}</option>
              ))}
            </select>
          </div>

          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <button
              onClick={handleWatch}
              style={{
                flex: 1,
                padding: "10px",
                background: "#4caf50",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontWeight: 500,
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              شروع تماشا با زیرنویس مرجع
            </button>
            <button
              onClick={onClose}
              style={{
                padding: "10px 16px",
                background: "var(--glass-bg-strong)",
                color: "var(--text-secondary)",
                border: "1px solid var(--glass-border)",
                borderRadius: "8px",
                fontWeight: 500,
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>,
    portalContainer,
  );
};

export default WatchReferenceModal;
